import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  addDealerBranch,
  changeOrderDate,
  createProductionOrder,
  deleteDealerBranch,
  editDealer,
  setMainDealerBranch,
} from "../../api/thunks";
import { DealerSliceState } from "../types";

export const addCrudExtraReducers = (
  builder: ActionReducerMapBuilder<DealerSliceState>,
) => {
  builder.addCase(editDealer.pending, (state) => {
    state.error = null;
    state.isMiniLoading = true;
  });
  builder.addCase(editDealer.fulfilled, (state) => {
    state.error = null;
    state.isMiniLoading = false;
  });
  builder.addCase(editDealer.rejected, (state, action) => {
    state.error = action.payload;
    state.isMiniLoading = false;
  });

  builder.addCase(addDealerBranch.pending, (state) => {
    state.error = null;
    state.isLoading = true;
    state.isMiniLoading = true;
  });
  builder.addCase(addDealerBranch.fulfilled, (state) => {
    state.isLoading = false;
    state.isMiniLoading = false;
    state.error = null;
  });
  builder.addCase(addDealerBranch.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
    state.isMiniLoading = false;
  });

  builder.addCase(deleteDealerBranch.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(deleteDealerBranch.fulfilled, (state) => {
    state.isLoading = false;
    state.error = null;
  });
  builder.addCase(deleteDealerBranch.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(setMainDealerBranch.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(setMainDealerBranch.fulfilled, (state) => {
    state.isLoading = false;
    state.error = null;
  });
  builder.addCase(setMainDealerBranch.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(changeOrderDate.pending, (state) => {
    state.error = null;
    state.isMiniLoading = true;
  });
  builder.addCase(changeOrderDate.fulfilled, (state, action) => {
    state.error = null;
    state.isMiniLoading = false;
    state.selectedDealerIds = [];
    state.isDatePickerActive = false;
    if (action.payload) {
      state.orderedDealers = action.payload.items;
    }
  });
  builder.addCase(changeOrderDate.rejected, (state, action) => {
    state.error = action.payload;
    state.isMiniLoading = false;
  });

  builder.addCase(createProductionOrder.pending, (state) => {
    state.error = null;
    state.isMiniLoading = true;
  });
  builder.addCase(createProductionOrder.fulfilled, (state) => {
    state.error = null;
    state.isMiniLoading = false;
    state.selectedDealerIds = [];
  });
  builder.addCase(createProductionOrder.rejected, (state, action) => {
    state.error = action.payload;
    state.isMiniLoading = false;
  });
};
